{
  "_comment": "Voice sample manifest. Keys are filenames (assets/voice/<key>.mp3). Values are the text to synthesise. Run generate_voice.py to produce any missing files.",

  "role_hunter":          "You are a hunter. Wait forty-five seconds to give the runners a head start.",
  "role_runner":          "You are a runner. Forty-five seconds head start. Run!",
  "hunt_begins":          "Hunt begins. Good luck.",
  "hunters_win":          "All runners eliminated. Hunters win!",
  "runners_win":          "Time expired. Runners win!",
  "no_hunters_win":       "No hunters left. Runners win!",
  "game_over":            "Game over.",
  "you_died":             "You have been eliminated.",
  "player_disconnected":  "A player has disconnected.",

  "grace_period":         "Not yet!",
  "firing":               "Firing.",
  "scanning":             "Scanning.",
  "hiding":               "Hiding. Thirty seconds.",
  "no_longer_hidden":     "You are no longer hidden.",
  "detection_active":     "Detection active. Sixty seconds.",
  "shield_on":            "Shield up. Twenty seconds of invincibility.",
  "recharging":           "Recharging. Hold position for 25 seconds.",
  "recharge_successful":   "Recharge successful.",
  "recharge_aborted":     "Recharge aborted due to movement.",
  "recharge_cooling_down": "Cannot recharge. Cooling down...",
  "return_to_base":       "Return to your base!",
  "stop_done":            "Abilities cancelled.",
  "talk_sent":            "Broadcasting position to team.",

  "_section_actions_v2":  "── reworked / new actions (prefixed by action name) ────",
  "ghost_on":             "Ghosting. Untargetable for thirty seconds.",
  "ghost_off":            "You are visible again.",
  "shield_blocked":       "Target shielded. No effect.",
  "bomb_armed":           "Bomb armed. Thirty seconds.",
  "explosive_deployed":   "Explosive deployed. Say ignite to detonate it.",
  "ignite_empty":         "No charges to ignite.",
  "sonar_armed":          "Sonar armed.",
  "sonar_contact":        "Sonar blip! Enemy nearby...",
  "track_locked":         "Target locked.",
  "track_update":         "Tracking...",
  "track_ended":          "Tracking ended.",
  "hulk_on":              "Berserk! Sixty seconds.",
  "hulk_off":             "Berserk mode ended.",
  "pulse_done":           "Electromagnetic pulse deployed! All nearby actions have been disrupted!",
  "pulse_none":           "Electromagnetic pulse deployed! No nearby actions detected.",
  "pulse_hit":            "We got hit by an electromagnetic pulse! Actions disrupted.",
  "lure_dropped":         "Lure dropped.",
  "action_not_enabled":   "That action is not enabled in this game.",

  "insufficient_credits": "Insufficient credits.",
  "wrong_role":           "Your role can't use that action.",
  "you_are_dead":         "You are out of the game.",
  "cannot_scan_hiding":   "Cannot scan while hiding.",
  "runners_cannot_fire":  "Runners cannot fire.",
  "hunters_cannot_shield":"Hunters cannot use shields.",
  "already_recharging":   "Already recharging.",

  "target_eliminated":    "Enemy down!",
  "no_target_in_range":   "No target in range.",
  "no_enemies_detected":  "No enemies detected.",
  "miss":                 "Missed.",

  "listening":            "Ready.",
  "error_cue":            "Error.",

  "welcome":              "Welcome to WildHunt!",
  "connected":            "Connected.",
  "disconnected":         "Disconnected.",
  "creating_game":        "Creating game!",
  "joining_game":         "Joining game!",
  "left_game":            "Left the game.",

  "help_text":            "Hunters: scan, fire, bomb. Runners: ghost, shield, bomb. Everyone: recharge, stop, status.",

  "enemy_at":             "Enemy at",
  "contact_enemy_within": "Contact. Enemy within",
  "enemy_recharging":  "Enemy is recharging.",
  "in_zone":              "In zone.",
  "outside_zone":         "Outside zone.",
  "role_is_hunter":       "Role: Hunter.",
  "role_is_runner":       "Role: Runner.",

  "enemy_located":        "Enemy located!",

  "_section_credits":     "── credits (cred_0 … cred_25) ─────────────────────────",
  "cred_0":  "0 credits.",
  "cred_1":  "1 credit.",
  "cred_2":  "2 credits.",
  "cred_3":  "3 credits.",
  "cred_4":  "4 credits.",
  "cred_5":  "5 credits.",
  "cred_6":  "6 credits.",
  "cred_7":  "7 credits.",
  "cred_8":  "8 credits.",
  "cred_9":  "9 credits.",
  "cred_10": "10 credits.",
  "cred_11": "11 credits.",
  "cred_12": "12 credits.",
  "cred_13": "13 credits.",
  "cred_14": "14 credits.",
  "cred_15": "15 credits.",
  "cred_16": "16 credits.",
  "cred_17": "17 credits.",
  "cred_18": "18 credits.",
  "cred_19": "19 credits.",
  "cred_20": "20 credits.",
  "cred_21": "21 credits.",
  "cred_22": "22 credits.",
  "cred_23": "23 credits.",
  "cred_24": "24 credits.",
  "cred_25": "25 credits.",

  "_section_time":        "── time remaining ──────────────────────────────────────",
  "time_just_seconds":    "Just seconds left.",
  "time_1_min":           "1 minute left.",
  "time_2_min":           "2 minutes left.",
  "time_3_min":           "3 minutes left.",
  "time_4_min":           "4 minutes left.",
  "time_5_min":           "5 minutes left.",
  "time_6_min":           "6 minutes left.",
  "time_7_min":           "7 minutes left.",
  "time_8_min":           "8 minutes left.",
  "time_9_min":           "9 minutes left.",
  "time_10_min":          "10 minutes left.",
  "time_11_min":          "11 minutes left.",
  "time_12_min":          "12 minutes left.",
  "time_13_min":          "13 minutes left.",
  "time_14_min":          "14 minutes left.",
  "time_15_min":          "15 minutes left.",
  "time_20_min":          "20 minutes left.",
  "time_25_min":          "25 minutes left.",
  "time_30_min":          "30 minutes left.",
  "time_35_min":          "35 minutes left.",
  "time_40_min":          "40 minutes left.",
  "time_45_min":          "45 minutes left.",
  "time_50_min":          "50 minutes left.",
  "time_55_min":          "55 minutes left.",
  "time_60_min":          "60 minutes left.",

  "_section_distances":   "── distances ───────────────────────────────────────────",
  "dist_10m":   "10 meters",
  "dist_25m":   "25 meters",
  "dist_50m":   "50 meters",
  "dist_100m":  "100 meters",
  "dist_200m":  "200 meters",
  "dist_300m":  "300 meters",
  "dist_400m":  "400 meters",
  "dist_500m":  "500 meters",
  "dist_750m":  "750 meters",
  "dist_1km":   "1 kilometer",
  "dist_1_5km": "1.5 kilometers",
  "dist_2km":   "2 kilometers",
  "dist_5km":   "5 kilometers",

  "_section_directions":  "── absolute compass directions (8-sector) ─────────────",
  "dir_n":  "To your North.",
  "dir_ne": "To your Northeast.",
  "dir_e":  "To your East.",
  "dir_se": "To your Southeast.",
  "dir_s":  "To your South.",
  "dir_sw": "To your Southwest.",
  "dir_w":  "To your West.",
  "dir_nw": "To your Northwest.",

  "_section_enemies":     "── enemy counts ────────────────────────────────────────",
  "enemies_0": "No enemies.",
  "enemies_1": "1 enemy.",
  "enemies_2": "2 enemies.",
  "enemies_3": "3 enemies.",
  "enemies_4": "4 enemies.",
  "enemies_5": "5 enemies.",
  "enemies_6": "6 enemies.",
  "enemies_7": "7 enemies.",
  "enemies_8": "8 enemies.",
  "enemies_9": "9 enemies.",

  "_section_allies":      "── ally counts ─────────────────────────────────────────",
  "allies_0": "No allies.",
  "allies_1": "1 ally.",
  "allies_2": "2 allies.",
  "allies_3": "3 allies.",
  "allies_4": "4 allies.",
  "allies_5": "5 allies.",
  "allies_6": "6 allies.",
  "allies_7": "7 allies.",
  "allies_8": "8 allies.",
  "allies_9": "9 allies."
}
